<template>
    <div class="px-1 pb-1">
        <b-modal id="job-exit-mediation" size="md" body-class="p-75" title="Arabuluculuk" no-close-on-esc no-close-on-backdrop>
            <employee-job-exit-mediation v-model="jobExitMediation"></employee-job-exit-mediation>
            <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="createOrUpdateMediation"></v-executer></template>
        </b-modal>
        
        <b-modal id="job-exit-detail" size="lg" body-class="p-75" title="İşten Çıkış Detayları" hide-footer no-close-on-esc no-close-on-backdrop>
            <employee-job-exit-detail v-model="jobExitMediation"></employee-job-exit-detail>
        </b-modal>

        <b-modal id="job-exit-temporary" size="sm" title="İşten Çıkış" no-close-on-esc no-close-on-backdrop>
            <employee-job-exit-temporary v-model="jobExitTemporary"></employee-job-exit-temporary>
            <template #modal-footer><v-executer :loading="exiting" text="Çıkış Yap" :action="exit"></v-executer></template>
        </b-modal>

        <b-modal id="nakil" size="sm" title="Nakil" no-close-on-esc no-close-on-backdrop>
            <employee-job-nakil v-model="nakilData" :errors="errors"></employee-job-nakil>
            <template #modal-footer><v-executer :loading="nakiling" text="Nakil" :action="nakil"></v-executer></template>
        </b-modal>

        <b-modal id="update-job-notice" size="sm" title="Güncelle" no-close-on-esc no-close-on-backdrop>
            <employee-job-notice-update v-model="updateData" :errors="errors"></employee-job-notice-update>
            <template #modal-footer><v-executer :loading="updating" text="Güncelle" :action="update"></v-executer></template>
        </b-modal>

        <b-modal id="upload" size="lg" :title="$safe(uploadObject,'Type') == 'abort' ? 'Giriş İptali' : 'Giriş Belgesi Yükleme'" scrollable no-close-on-esc no-close-on-backdrop>
            <employee-job-entry-abort v-model="uploadObject"></employee-job-entry-abort>
            <template #modal-footer><v-executer :loading="uploading" :action="upload" :disabled="!uploadObject.File">{{ $safe(uploadObject,'Type') == 'abort' ? 'Girişi İptal Et' : 'Giriş Dosyası Yükle' }}</v-executer></template>
        </b-modal>

        <!-- Madde 23: Yillik izin hakedisinde baz alinacak tarih.
             SGK giris/cikis hareketleriyle ayni ekranda, listenin ustunde. -->
        <employee-annual-leave-base-date v-if="id" :id="String(id)"></employee-annual-leave-base-date>

        <b-overlay :show="noticesLoading" opacity="0.2" rounded="sm" :class="!connectedData.length ? 'p-3' : 'p-0'">
            <v-connected v-model="connectedData" >
                <template #data="{data}">
                    <template v-if="$safe(data,'Type') == 'GIRIS'">
                        <div class="table-responsive mb-0">
                            <table class="table table-sm table-bordered header-bordered">
                                <thead>
                                    <tr>
                                        <th class="text-nowrap w-20">Hareket Türü</th>
                                        <th class="text-nowrap w-20">Tarih</th>
                                        <th class="text-nowrap w-20">İş Yeri</th>
                                        <th class="text-nowrap w-20">Tebliğ Tarihi</th>
                                        <th class="text-nowrap w-20">TMS Bildirim Tarihi</th>
                                        <th class="text-nowrap"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="font-weight-bolder text-success">GİRİŞ</td>
                                        <td class="font-weight-bolder">{{$safe(data,'Date')||'-'}}</td>
                                        <td class="font-weight-bolder">{{$safe(data,'SGKBranch.Name')||'-'}}</td>
                                        <td>{{$safe(data,'NotifyDate')||'-'}}</td>
                                        <td>{{$safe(data,'ProcessDate')||'-'}}</td>
                                        <td class="p-25 bg-light">
                                            <b-dropdown variant="primary" right  boundary="parent" text="İşlemler" size="sm">
                                                <b-dropdown-item v-on:click="showUpdate(data)">Düzenle</b-dropdown-item>
                                                <b-dropdown-item v-on:click="showExit(data)" v-if="data.Exit == null">Çıkış Ver</b-dropdown-item>
                                                <b-dropdown-item v-if="data.Exit == null" v-on:click="uploadAbort(data.Id)">İptal</b-dropdown-item>
                                                <b-dropdown-item v-if="data.Exit == null" v-on:click="uploadEntry(data.Id)">Giriş Belgesi Yükle</b-dropdown-item>
                                                <b-dropdown-item v-if="data.Deletable && data.Exit == null" v-on:click="showNakil(data)">Nakil</b-dropdown-item>
                                                <!-- <b-dropdown-item v-if="data.Deletable && data.Exit == null" v-on:click="deleteEntry(data)" :disabled="deleting">Sil</b-dropdown-item> -->
                                                <b-dropdown-item v-if="data.RefCode != null" :disabled="savingPdf" v-on:click="savePDF(data)">PDF'i Belgere Kaydet</b-dropdown-item>
                                            </b-dropdown>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </template>
                    <template v-else>
                        <div class="table-responsive mb-0">
                            <table class="table table-sm table-bordered header-bordered">
                                <thead>
                                    <tr>
                                        <th class="text-nowrap w-20">Hareket Türü</th>
                                        <th class="text-nowrap w-20">Tarih</th>
                                        <th class="text-nowrap w-20">İş Yeri</th>
                                        <th class="text-nowrap w-20">Tebliğ Tarihi</th>
                                        <th class="text-nowrap w-20">TMS Bildirim Tarihi</th>
                                        <th class="text-nowrap"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="font-weight-bolder text-danger">{{ $safe(data,'TransferTo') == null ? 'ÇIKIŞ' : 'NAKİL' }} {{$safe(data,'EYT') ? '(EYT)' : ''}}</td>
                                        <td class="font-weight-bolder">{{$safe(data,'Date')||'-'}}</td>
                                        <td class="font-weight-bolder">{{$safe(data,'SGKBranch.Name')||'-'}}</td>
                                        <td>{{$safe(data,'NotifyDate')||'-'}}</td>
                                        <td>{{$safe(data,'ProcessDate')||'-'}}</td>
                                        <td class="p-25 bg-light">
                                            <b-dropdown variant="primary" right  boundary="parent" text="İşlemler" size="sm">
                                                <b-dropdown-item v-on:click="showUpdate(data)">Düzenle</b-dropdown-item>
                                                <b-dropdown-item v-on:click="mediation(data)">Arabulucuk</b-dropdown-item>
                                                <b-dropdown-item v-on:click="detail(data)">Detay</b-dropdown-item>
                                                <b-dropdown-item v-on:click="deleteExit(data)" :disabled="deleting">Sil</b-dropdown-item>
                                            </b-dropdown>
                                        </td>
                                    </tr>
                                    <tr v-if="data.ParentJobExitSpecialCauseName && data.JobExitSpecialCauseName">
                                        <td colspan="20">
                                            {{data.ParentJobExitSpecialCauseName}} -> {{ data.JobExitSpecialCauseName }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </template>
                </template>
            </v-connected>
        </b-overlay>
    </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import EmployeeOperationsApi from '@/api/employee-operations'
import EmployeeJobExitMediation from './EmployeeJobExitMediation.vue'
import VTreeView from '@/components/v-tree-view/VTreeView'
import { BOverlay, BDropdown, BDropdownItem } from 'bootstrap-vue'
import EmployeeJobExitDetail from './EmployeeJobExitDetail.vue'
import VConnected from '@/components/VConnected.vue'
import EmployeeJobExitTemporary from './EmployeeJobExitTemporary.vue'
import EmployeeJobNakil from './EmployeeJobNakil.vue'
import VValidator from '@/components/VValidator.vue'
import EmployeeJobNoticeUpdate from './EmployeeJobNoticeUpdate.vue'
import moment from 'moment'
import EmployeeJobEntryAbort from './EmployeeJobEntryAbort.vue'
import Additional from '@/utilities/additional'
import EmployeeAnnualLeaveBaseDate from './EmployeeAnnualLeaveBaseDate.vue'

export default {
    components:{
        EmployeeJobExitMediation,
        EmployeeJobExitDetail,
        VTreeView,
        BOverlay,
        VConnected,
        VuePerfectScrollbar,
        EmployeeJobExitTemporary,
        EmployeeJobNakil,
        VValidator,
        BDropdown, 
        BDropdownItem,
        EmployeeJobNoticeUpdate,
        EmployeeJobEntryAbort,
        EmployeeAnnualLeaveBaseDate
    },
    props:{
        getPersonal:Function,
        id:[String,Number],
    },
    data(){
        return{
            notices:[],
            deleting:false,
            jobExitMediation:{
                Id:null,
                SgkJobNoticeId:null,
                Agreed:null,
                Description:null,
                PaymentDeadline:null,
                PaymentAmount:null,
            },
            loading:false,
            editing:false,
            noticesLoading:false,
            jobExitTemporary:{
                SGKBranchId:null,
                EmployeeId:null,
                ExitDate:null,
                EYT:false,
                Harmful:false,
            },
            exiting:false,
            savingPdf:false,
            nakiling:false,
            nakilData:{
                NotifyDate:null,
                iseGirisTarihi:null,
                OccupationTitleId:null,
                meslekkodu:null,
                branchId:null
            },
            errors:{},
            updateData:{
                Id:null,
                BranchId:null,
                Date:null,
                EYT:null,
                Harmful:false,
                HarmfulReason:null,
                Dummy:false,
                Type:null
            },
            updating:false,
            uploading:false,
            uploadObject:{
                Id:null,
                Type:null,
                Fine:null
            }
        }
    },
    mounted(){
        this.getNotices()
    },
    methods:{
        clearForm(){
            this.editing = false
            this.jobExitMediation.SgkJobNoticeId = null
            this.jobExitMediation.Id = null
            this.jobExitMediation.Agreed = null
            this.jobExitMediation.PaymentAmount = null
            this.jobExitMediation.PaymentDeadline = null
            this.jobExitMediation.Description = null
        },
        getNotices(){
            this.noticesLoading = true
            EmployeeOperationsApi.Employee.SGK.GetNotices(this.id).then(res=>{
                this.notices = res.data.Data
                this.noticesLoading = false
            })
        },
        mediation(item){
            this.clearForm()
            this.jobExitMediation.SgkJobNoticeId = item.Id
            if(item.Mediation){
                this.editing = true
                this.jobExitMediation.Agreed = item.Mediation.Agreed
                this.jobExitMediation.Id = item.Mediation.Id
                this.jobExitMediation.PaymentAmount = item.Mediation.PaymentAmount
                this.jobExitMediation.PaymentDeadline = item.Mediation.PaymentDeadline
                this.jobExitMediation.Description = item.Mediation.Description
            }
            this.$showModal('job-exit-mediation')
        },
        detail(item){
            this.clearForm()
            this.jobExitMediation.SgkJobNoticeId = item.EntryId
            this.$showModal('job-exit-detail')
        },
        createOrUpdateMediation(){
            this.loading = true

            if(this.jobExitMediation.Agreed){
                this.jobExitMediation.Description = null
            }else{
                this.jobExitMediation.PaymentAmount = null
                this.jobExitMediation.PaymentDeadline = null
            }

            EmployeeOperationsApi.Employee.SGK.CreateOrUpdateMeaditon(this.editing,this.jobExitMediation).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.getNotices()
                    this.$hideModal('job-exit-mediation')
                }
            }).catch(err=>{
                this.$result(null,err)
                this.loading = false
            })
        },
        clearJobExitTemporary(){
            this.jobExitTemporary.SGKBranchId = null
            this.jobExitTemporary.EmployeeId = null
            this.jobExitTemporary.ExitDate = null
        },
        showExit(data){
            this.clearJobExitTemporary()
            this.jobExitTemporary.SGKBranchId = data.SGKBranch?.Id || null
            this.jobExitTemporary.EmployeeId = this.id
            this.$showModal('job-exit-temporary')
        },
        showNakil(){
            this.nakilData.NotifyDate = null
            this.nakilData.iseGirisTarihi0 = null,
            this.nakilData.OccupationTitleId = null,
            this.nakilData.meslekkodu = null
            this.nakilData.branchId = null
            this.$showModal('nakil')
        },  
        exit(){
            this.exiting = true
            EmployeeOperationsApi.Employee.SGK.JobExitTemporary(this.jobExitTemporary).then(res=>{
                this.exiting = false
                this.$result(res)
                if(res.data.Success){
                    this.$hideModal('job-exit-temporary')
                    this.getNotices()
                    this.getPersonal()
                }
            }).catch(err=>{
                this.exiting = false
                this.$result(null,err)
            })
        },
        deleteEntry(data){
            this.$confirm('Personel Girişini Sil','Personel girişini silmek istediğinize emin misiniz? Bu işlem geri alınamaz.').then(result=>{
                if(result){
                    this.deleting = true
                    EmployeeOperationsApi.Employee.SGK.Delete(data.Id).then(res=>{
                        this.$result(res)
                        this.deleting = false
                        if(res.data.Success){
                            this.getNotices()
                            this.getPersonal()
                        }
                    }).catch(err=>{
                        this.deleting = true
                        this.$result(null,err)
                    })
                }
            })
        },
        deleteExit(data){
            this.$confirm('Personel Çıkışını Sil','Personel çıkışını silmek istediğinize emin misiniz? Bu işlem geri alınamaz.').then(result=>{
                if(result){
                    this.deleting = true
                    EmployeeOperationsApi.Employee.SGK.DeleteExit(data.Id).then(res=>{
                        this.$result(res)
                        this.deleting = false
                        if(res.data.Success){
                            this.getNotices()
                            this.getPersonal()
                        }
                    }).catch(err=>{
                        this.deleting = true
                        this.$result(null,err)
                    })
                }
            })
        },
        savePDF(data){
            this.savingPdf = true
            EmployeeOperationsApi.Employee.SGK.GetPDF(data.RefCode).then(res=>{
                this.savingPdf = false
                this.$result(res)
                if(res.data.Success){
                    this.getNotices()
                    this.getPersonal()
                }
            }).catch(err=>{
                this.savingPdf = false
                this.$result(null,err)
            })
        },
        nakil(){
            this.nakiling = true
            EmployeeOperationsApi.Employee.SGK.NakilKayit({
                ayniIsverenFarkliIsyeriNakil:false,
                nakilGeldigiIsyeriSicil:null,
                BranchId:this.nakilData.branchId,
                SGK:false,
                personeller:[{
                    EmployeeId: this.id,
                    OccupationTitleId: this.nakilData.OccupationTitleId || '',
                    meslekkodu: this.nakilData.meslekkodu || '',
                    NotifyDate: this.nakilData.NotifyDate || '',
                    iseGirisTarihi: this.nakilData.iseGirisTarihi || '',
                }],
            }).then(res=>{
                this.nakiling = false
                this.$result(res)
                if(res.data.Success){
                    this.$hideModal('nakil')
                    this.getNotices()
                    this.getPersonal()
                }
            }).catch(err=>{
                this.nakiling = false
                this.$result(null,err)
            })
        },
        showUpdate(item){
            this.updateData.Id = null
            this.updateData.BranchId = null
            this.updateData.Date = null
            this.updateData.EYT = null
            this.updateData.Harmful = false
            this.updateData.HarmfulReason = null
            this.updateData.Dummy = false
            this.updateData.Type = null
            this.updateData.Id = item.Id
            this.updateData.BranchId = item.SGKBranch?.Id || null
            this.updateData.Date = item.Date ? moment(item.Date,'DD.MM.YYYY').format('YYYY-MM-DD') : null
            this.updateData.EYT = item.EYT || false
            // Harmful personelin kendi kaydından, Dummy çıkış kaydından gelir (backend doldurur).
            this.updateData.Harmful = item.Harmful || false
            this.updateData.HarmfulReason = item.HarmfulReason || null
            this.updateData.Dummy = item.Dummy || false
            this.updateData.Type = item.Type == 'GIRIS' ? 'GIRIS' : item.TransferTo != null ? 'TRANSFER' : 'CIKIS'
            this.$showModal('update-job-notice')
        },
        update(){
            this.updating = true
            EmployeeOperationsApi.Employee.SGK.Update(this.updateData)
            .then(res=>{
                this.updating = false
                this.$result(res)
                if(res.data.Success){
                    this.$hideModal('update-job-notice')
                    this.getNotices()
                    this.getPersonal()
                }
            }).catch(err=>{
                this.updating = false
                this.$result(null,err)
            })
        },
        uploadAbort(id){
            this.uploadObject.Id = id
            this.uploadObject.Type = 'abort'
            this.uploadObject.File = null
            this.$showModal('upload')
        },
        uploadEntry(id){
            this.uploadObject.Id = id
            this.uploadObject.Type = 'entry'
            this.uploadObject.File = null
            this.$showModal('upload')
        },
        async upload(){
            this.uploading = true
            let formData = await Additional.ToFormData(this.uploadObject,['File'])

            const api = this.uploadObject.Type == 'abort' 
                ? EmployeeOperationsApi.Employee.SGK.AbortEntry
                : EmployeeOperationsApi.Employee.SGK.UploadEntryDoc

            api(formData).then(res => {
                if(res.data.Success){
                    this.getNotices()
                    this.getPersonal()
                    this.$hideModal('upload')
                }
                this.$result(res)
                this.uploading = false
            }).catch(err => {
                this.uploading = false
                this.$result(null,err)
            })
        }
    },
    computed:{
        connectedData(){
            return this.notices?.map(n=>{
                if(n.Exit){
                    return [{...n.Exit,EntryId:n.Id}, n]
                }else{
                    return [n]
                }
                
            })
        }
    }
}
</script>

<style>
.notice-entry{
    border-radius: 5px;
    padding: 0.5rem;
    border: 1px solid  #ebe9f1;
}
.dark-layout  .notice-entry{
        border-color: hsl(255, 22%, 50%);
    }
</style>